import request from "@/utils/request";

// 出生死亡数统计
const dataBirthDead = (params) => {
  return request({
    url: "/api/farm/data/center/birth/dead",
    method: "get",
    params,
  });
};
//养殖场规模分布
const dataDistribution = (params) => {
  return request({
    url: `/api/farm/data/center/village/distribution`,
    method: "get",
    params,
  });
};

//养殖场畜禽排行
const dataLivestockRank = (id, params) => {
  return request({
    url: `/api/farm/data/center/village/livestock/rank/${id}`,
    method: "get",
    params,
  });
};
//出入栏数据比对
const dataAccessContrast = (params) => {
  return request({
    url: `/api/farm/data/center/village/access/contrast`,
    method: "get",
    params,
  });
};
// 牛羊分类统计
const dataAssortSta = (params) => {
  return request({
    url: `/api/farm/data/center/village/st/type`,
    method: "get",
    params,
  });
};
// 主要饲料消耗量统计
const dataFeedReport = (regionCode) => {
  return request({
    url: `/api/farm/data/center/feed/report/${regionCode}`,
    method: "get",
  });
};

/**
 * 防疫接种统计
 * @param {*} params
 * @param {*} type  epidemic prevention
 * @returns
 */
const dataEpidemicAndPrevention = (params) => {
  console.log("prevention param:", params);
  return request({
    url: `/api/farm/data/center/village/epidemic/prevention`,
    method: "get",
    params,
  });
};

export default {
  dataFeedReport,
  dataAssortSta,
  dataBirthDead,
  dataDistribution,
  dataLivestockRank,
  dataAccessContrast,
  dataEpidemicAndPrevention,
};
